import { IssueCaseDoc, OrderDoc, StoreDoc } from '@gooduncles/gu-app-schema';
import { FC } from 'react';

import { isIssueCaseEditable } from 'src/utils/issue/issue-util';

import IssueOrderCard from 'src/atomic-components/molecules/IssueOrderCard/IssueOrderCard';
import LinkedMessagesSection from 'src/components/Issue/MessageLink/LinkedMessagesSection';

import styles from './IssuePanel.module.scss';

import CasedIssueCaseCard from '../IssueCaseCard/CasedIssueCaseCard';

interface IssueTargetSectionProps {
  order?: OrderDoc;
  issue?: IssueCaseDoc;
  /** target(order/issue)이 없는 단독 이슈 — 좌측에 연결 메시지만 단독 표시 */
  standaloneIssue?: IssueCaseDoc;
  store?: StoreDoc;
  issueCases: IssueCaseDoc[];
  onIssueCaseClick: (caseId: string) => void;
  style?: React.CSSProperties;
}

const IssueTargetSection: FC<IssueTargetSectionProps> = ({
  order,
  issue,
  standaloneIssue,
  store,
  issueCases,
  onIssueCaseClick,
  style,
}) => {
  return (
    <div className={styles.columnContent} style={style}>
      {order && store && (
        <IssueOrderCard store={store} order={order} issueCases={issueCases} onIssueCaseClick={onIssueCaseClick} />
      )}
      {issue && <CasedIssueCaseCard issueCaseDoc={issue} issueCases={issueCases} />}
      {!order && !issue && standaloneIssue && (
        <LinkedMessagesSection issueCase={standaloneIssue} editable={isIssueCaseEditable(standaloneIssue)} />
      )}
    </div>
  );
};

export default IssueTargetSection;
